<template>
    <div id="VistaDeInformacion_div" class="w-100 px-5 py-4">
      <div id="TituloVistaDeinformacion_div">
        <h1 style="margin-bottom: 0px;">INFORMACIÓN DE LA AUDIENCIA</h1>
        <h3 style="margin-top: 0px;">{{Audiencia.TipoDocumento.Nombre}} {{Audiencia.Consecutivo}}</h3>
      </div>
      <div class="row d-flex">
        <div id="DetalleVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <h2>Información</h2>
            <hr />
            <p><strong>Juzgado: </strong><br />{{Audiencia.Area.Nombre}}</p>
            <p><strong>Materia: </strong><br />{{Audiencia.Materia.Nombre}}</p>
            <p><strong>Tipo de documento: </strong><br />{{Audiencia.TipoDocumento.Nombre}}</p>
            <p><strong>Consecutivo: </strong><br />{{Audiencia.Consecutivo}}</p>
            <p><strong>Tipo de audiencia: </strong><br />{{Audiencia.TipoAudiencia.Nombre}}</p>
            <p><strong>Fecha: </strong><br />{{Audiencia.FechaAudiencia}}</p>
            <p><strong>Sala: </strong><br />{{Audiencia.Sala.Nombre}}</p>
            <p><strong>Estatus de la audiencia: </strong><br />{{Audiencia.TipoEstatusDeAudiencia.Nombre}}</p>
          </div>
        </div>
        <div id="ContenidoVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <!--<button @click="componente='Detalles'" class="btn btn-primary">Detalles</button>
  <button @click="componente='Video'" class="btn btn-primary">Audiencia</button>-->
            <!--<hr />-->
            <h2>Información de la audiencia</h2>
            <hr />
            <component :is="componente" v-bind:Audiencia="Audiencia" :AudienciaId="AudienciaId">
            </component>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  import detalles from '@/../src/components/Forseti/Consultas/PanelDeAudienciasFinalizadas/_Detalles.vue';

  export default {
    components: {
      Detalles: detalles
    },
    data() {
      return {
        comun,
        enumeraciones,
        Audiencia: {
          AudienciaId:Number,
          Area: { Nombre: String },
          Materia: { Nombre: String },
          TipoAudiencia: {
            Nombre: String
          },
          TipoDocumento: {
            Nombre: String
          },
          Fecha: String,
          HoraDeInicio: String,
          HoraFinalizada: String,
          Jueces: [
            { Nombre: String }
          ],
          Sala: { Nombre: String},
          TipoEstatusDeAudiencia: {
            TipoEstatusDeAudienciaId: Number,
            Nombre: String
          }
        },
        componente: "Detalles"
      }
    },
    props: {
      AudienciaId: Number
    },
    mounted() {
      if (this.AudienciaId != null && this.AudienciaId != undefined && this.AudienciaId > 0) {
        this.busquedaAudiencia();
      }
    },
    methods: {
      busquedaAudiencia() {        
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(          
          api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.GetAudienciaFinalizada,     
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {          
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {            
            //CargarDatos de audiencia            
            this.Audiencia = respuesta.data.AudienciaFinalizada;            
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor" , e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Consultas/PanelDeAudienciasFinalizadas/VistaDeInformacion.vue